import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { PostHogProvider, usePostHog } from 'posthog-js/react';
import { msalConfig } from './auth/authConfig';
import App from './App';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// PostHog configuration
const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  person_profiles: 'identified_only',
  defaults: '2025-05-24',
  persistence: 'localStorage', // Use localStorage instead of cookies
  disable_cookie: true, // Explicitly disable cookies
  opt_out_capturing_by_default: false,
};

// Component to expose PostHog globally
function PostHogGlobalizer() {
  const posthog = usePostHog();
  
  useEffect(() => {
    if (posthog) {
      window.posthog = posthog;
    }
  }, [posthog]);
  
  return null;
}

// Initialize MSAL before rendering
msalInstance.initialize().then(() => {
  // Small delay to ensure MSAL is fully ready
  setTimeout(() => {
    // Handle automatic sign-in for existing sessions
    const accounts = msalInstance.getAllAccounts();
    
    if (accounts.length > 0) {
      // Set the first account as the active account
      msalInstance.setActiveAccount(accounts[0]);
      console.log('Found existing account, setting as active:', accounts[0].username);
    } else {
      console.log('No existing accounts found during initialization');
    }
    
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={posthogOptions}>
          <PostHogGlobalizer />
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </PostHogProvider>
      </React.StrictMode>
    );
  }, 100); // Small delay to ensure MSAL cache is loaded
}).catch(error => {
  console.error('Failed to initialize MSAL:', error);
});